import { render, staticRenderFns } from "./CalendarBanner.vue?vue&type=template&id=ef00a986&scoped=true"
import script from "./CalendarBanner.vue?vue&type=script&lang=ts"
export * from "./CalendarBanner.vue?vue&type=script&lang=ts"
import style0 from "./CalendarBanner.vue?vue&type=style&index=0&id=ef00a986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef00a986",
  null
  
)

export default component.exports